<template>
  <nav class="navbar bg-nav">
    <router-link to="/home">
      <img class="bs-logo" src="@/assets/images/icons/bs-logo-beta.svg">
    </router-link>

  </nav>
</template>

<script>

export default {
  name: 'BlankNavbar',
  data () {
    return {

    }
  }
}
</script>

<style lang="scss" scoped>

.bg-nav {
  background:                 #F8F8F8;
  border-bottom:              1px solid #DEDEDE;
  width:                      100%;
  padding:                    0.5em 1.5em;
  position:                   fixed;
  height:                     3.6em;
  z-index:                    999998;
  width:                      100%;

  .bs-logo {
    width:                    2em;
    height:                   2em;
  }
}


/* Landscape phone to portrait tablet */
@media (max-width: 767px) {

  .bg-nav {
    padding:                  0.5em 1em;
  }

}


</style>



// WEBPACK FOOTER //
// src/components/BlankNavbar.vue